module.exports = __webpack_public_path__ + "img/borderRing3White.a79ab64f.svg";